import { action, observable } from "mobx"

import AppConsts from "./../lib/appconst"
import LoginModel from "@models/account/Login/loginModel"
import tokenAuthService from "@services/tokenAuth/tokenAuthService"

declare let abp: any

class AuthenticationStore {
  @observable isLoading!: boolean
  @observable loginModel: LoginModel = new LoginModel()
  @observable firebaseBody: any = {}
  get isAuthenticated(): boolean {
    if (!abp.session.userId) return false

    return true
  }

  @action public async checkPhoneNumber(phoneNumber) {
    const result = await tokenAuthService.checkPhoneNumber(phoneNumber)
    return result
  }
  // checkSocial removed together with the self-registration flows
  // (it only pre-checked first-time social sign-ups).
  @action
  public async login(model: LoginModel) {
    this.isLoading = true
    const result = await tokenAuthService
      .authenticate(
        {
          userNameOrEmailAddress: model.userNameOrEmailAddress.trim(),
          password: model.password,
          rememberClient: model.rememberMe,
        },
        // login page surfaces errors inline (AuthErrorBanner) — no global toast
        { skipErrorNotification: true }
      )
      .finally(() => (this.isLoading = false))

    // Buộc đổi mật khẩu lần đầu: TokenAuthController trả ShouldResetPassword và KHÔNG
    // cấp token. Phải dừng ở đây — chạy tiếp sẽ ghi accessToken = undefined vào cookie,
    // khiến mọi request sau đó trả 401 và người dùng bị văng ra trong vòng lặp.
    if (result?.shouldResetPassword) {
      return result
    }

    // Cookie phiên (hết khi đóng trình duyệt) làm SignalR chết ngay khi mở lại tab,
    // nên token luôn ghi dạng PERSISTENT 10 năm — chỉ logout (hoặc 401/406) mới xoá.
    // Checkbox "Ghi nhớ đăng nhập" giờ chỉ còn tác dụng qua rememberClient ở backend.
    const tokenExpireDate = new Date(new Date().getTime() + 1000 * 315360000)
    abp.auth.setToken(result.accessToken, tokenExpireDate)
    abp.utils.setCookieValue(
      AppConsts.authorization.encrptedAuthTokenName,
      result.encryptedAccessToken,
      tokenExpireDate,
      "/",
      undefined,
      {
        Secure: true,
        SameSite: "Lax",
        MaxAge: 315360000,
        path: "/",
      }
    )

    return result
  }
  @action
  public async loginSocial(body) {
    this.isLoading = true
    const result = await tokenAuthService
      .socialAuth(
        {
          ...this.firebaseBody,
          ...body,
        },
        // login page surfaces errors inline (AuthErrorBanner) — no global toast
        { skipErrorNotification: true }
      )
      .finally(() => (this.isLoading = false))

    // Set token expire date to 10 years (315360000 seconds)
    const tokenExpireDate = new Date(new Date().getTime() + 1000 * 315360000)
    abp.auth.setToken(result.accessToken, tokenExpireDate)
    abp.utils.setCookieValue(
      AppConsts.authorization.encrptedAuthTokenName,
      result.encryptedAccessToken,
      tokenExpireDate,
      "/",
      undefined,
      { 
        Secure: true, 
        SameSite: "Lax", 
        MaxAge: 315360000,
        path: "/"
      }
    )
  }
  @action public async loginSMS(body) {
    this.isLoading = true
    const result = await tokenAuthService
      .SMSAuth(body)
      .finally(() => (this.isLoading = false))

    // Set token expire date to 10 years (315360000 seconds)
    const tokenExpireDate = new Date(new Date().getTime() + 1000 * 315360000)
    abp.auth.setToken(result.accessToken, tokenExpireDate)
    abp.utils.setCookieValue(
      AppConsts.authorization.encrptedAuthTokenName,
      result.encryptedAccessToken,
      tokenExpireDate,
      "/",
      undefined,
      { 
        Secure: true, 
        SameSite: "Lax", 
        MaxAge: 315360000,
        path: "/"
      }
    )
  }
  @action public async getMethod() {
    this.isLoading = true
    const res = await tokenAuthService
      .getLoginMethod()
      .finally(() => (this.isLoading = false))
    return res
  }
  // Self-registration actions removed together with the /account/register
  // flows: CRM là hệ thống nội bộ, tài khoản do Administrator cấp.
  @action
  logout() {
    abp.utils.deleteCookie(
      AppConsts.authorization.encrptedAuthTokenName,
      abp.appPath
    )
    abp.utils.deleteCookie(AppConsts.authorization.projectId, abp.appPath)

    localStorage.clear()
    sessionStorage.clear()
    abp.auth.clearToken()
  }
}
export default AuthenticationStore
